import { getUserAvatar } from '../../../utils/user'
import { BUTTON_HEIGHT_40 } from '../../Button'
import {
  EntityProfileHeader,
  EntityProfileHeaderTitleWithStatus,
} from '../../Entity'
import { useUserProfileContext } from '../User.hooks'
import { getUserProfileCanEdit } from '../User.utils'
import { UserStatusTag } from '../UserStatusTag'

import * as styles from './UserProfileHeader.module.css'

function UserProfileHeader({
  Footer = null,
  footerProps,
  infoItemsProps,
  sectionBackUrl,
  textProps,
  onClickEditTitleButton,
}) {
  const {
    handleCloseModal,
    handleEntityReload,
    handleUpdateEntity,
    isInitiated,
    setModal,
    userData,
  } = useUserProfileContext()

  return (
    <EntityProfileHeader
      Footer={Footer}
      Header={EntityProfileHeaderTitleWithStatus}
      footerProps={footerProps}
      headerProps={{
        Status: UserStatusTag,
        backButtonProps: {
          height: BUTTON_HEIGHT_40,
        },
        className: styles.title,
        entityAvatarProps: userData
          ? {
              ...getUserAvatar(userData),
              editable: getUserProfileCanEdit(userData),
              setModal,
              onCloseModal: handleCloseModal,
              onEntityReload: handleEntityReload,
              onUpdateEntity: handleUpdateEntity,
            }
          : null,
        isArchived: userData?.isArchived,
        sectionBackUrl,
        statusProps: {
          value: userData?.status,
        },
        text: userData?.fullname,
        textProps,
        toggleButtonProps: {
          height: BUTTON_HEIGHT_40,
        },
      }}
      infoItemsProps={infoItemsProps}
      isLoading={!isInitiated}
      onClickEditTitleButton={onClickEditTitleButton}
    />
  )
}

export default UserProfileHeader
